export default {
  header: {
    back: {
      url: 'http://chaumet.com/fr',
      content: 'retour sur chaumet.com'
    }
  },
  playerCover: {
    title: 'Les Mondes<br> de Chaumet',
    content: 'Du 28 juin au 17 Septembre 2018',
    idYt: 'aXMgQ6xpdPg',
    cover: 'home/player/cover.jpg',
    legend: 'Video'
  },
  scrollCta: 'faites défiler pour en voir plus',
  worldDiscover: {
    title: {
      firstPart: 'découvrir',
      secondPart: 'les mondes'
    },
    content:
      'A l’occasion de son exposition au Mitsubishi Ichigokan Museum de Tokyo, Chaumet invite à un nouveau voyage dans l’histoire, la culture, le savoir-faire et le style de la Maison.',
    worlds: {
      types: [
        {
          title: 'Joséphine',
          content: 'La femme Chaumet, muse de la Maison.',
          img: 'home/world/josephine.jpg',
          url: 'josephine'
        },
        {
          title: 'La Maison Chaumet',
          content: 'Premier joaillier, au numéro<br/> 12  place Vendôme.',
          img: 'home/world/chaumet.jpg',
          url: 'maison'
        },
        {
          title: 'Chaumet et le Japon',
          content: 'Une invitation au voyage.',
          img: 'home/world/japon.jpg',
          url: 'japon'
        },
        {
          title: 'La nature',
          content: 'Source infinie d’inspiration.',
          img: 'home/world/nature.jpg',
          url: 'nature'
        },
        {
          title: "L'art du diadème",
          content: 'La création en tête.',
          img: 'home/world/art.jpg',
          url: 'diademe'
        },
        {
          title: 'Le choix des souverains',
          content: 'La tiare du Pape Pie VII, symbole du pouvoir.',
          img: 'home/world/pape.jpg',
          url: 'souverains'
        },
        {
          title: 'Les bijoux de sentiment',
          content: 'Célébrer les grands moments de bonheur.',
          img: 'home/world/sentimental.jpg',
          url: 'sentimental'
        },
        {
          title: 'L’art du bijou transformable',
          content: 'Le savoir-faire et la virtuosité.',
          img: 'home/world/transformer.jpg',
          url: 'transformer'
        }
      ],
      cta: 'Découvrir'
    },
    legend: 'Mondes'
  },
  wall: {
    title: '#TheWorldsOfChaumet',
    content:
      "L'exposition illustre la façon dont Chaumet s'est ouvert à l'ensemble du monde dès la seconde moitié du 19ème siècle, captant les influences les plus diverses, diffusant en retour son style parisien, et s'imposant comme un acteur majeur de l'histoire du goût. <br/><br/>Chaumet rend en particulier hommage au Japon et à la culture japonaise, avec lesquels elle entretient des liens étroits depuis la fin du 18ème siècle.",
    previous: 'Précédent',
    next: 'Suivant',
    cta: 'en voir plus',
    legend: '#TheWorldsOfChaumet'
  },
  footer: {
    title: 'Informations pratiques',
    exposition: {
      title: 'Exposition Les Mondes de Chaumet',
      content:
        'Du 28 juin au 17 septembre 2018, au Mitsubishi Ichigokan Museum à Tokyo.'
    },
    museum: {
      link: {
        title: 'Accéder au site du musée',
        url: 'https://mimt.jp/chaumet/'
      },
      logo: 'home/museum-logo.png'
    },
    legend: 'Informations pratiques',
    links: [
      { logo: 'social/fb.png', url: 'https://www.facebook.com/Chaumet' },
      {
        logo: 'social/insta.png',
        url: 'https://www.instagram.com/chaumetofficial/'
      },
      { logo: 'social/yt.png', url: 'https://youtube.com/user/Chaumet' },
      { logo: 'social/gplus.png', url: 'https://plus.google.com/+chaumet' },
      { logo: 'social/pint.png', url: 'https://www.pinterest.fr/chaumet/' },
      { logo: 'social/twitter.png', url: 'https://twitter.com/Chaumet' },
      {
        logo: 'social/line.png',
        url: 'https://line.me/R/ti/p/%40chaumetofficial'
      },
      { logo: 'social/wechat.png' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/locales/fr/home.js